import React, { useState } from "react"
import {
  AccordionExample,
  AdsExample,
  AnimatorExample,
  ButtonExample,
  CardNavigationExample,
  CarouselExample,
  CheckboxExample,
  ChipExample,
  CurrencyInputExample,
  DatePickerExample,
  FormSelectExample,
  GridExample,
  HintExample,
  IconExample,
  ImageExample,
  InputExample,
  LabelExample,
  ListExample,
  LoginExample,
  MapExample,
  ModalExample,
  PaginationExample,
  PrivacidadeExample,
  BulletExample,
  RadioExample,
  TextExample,
  SelectExample,
  StatusExample,
  SegmentedControlExample,
  TouchableExample,
  QRCodeExample,
  TestsExample,
  ToggleExample,
  SliderExample,
  SellerPerfilExample,
  TextLinkExample,
  ValueInputExample,
  ViewExample,
  VideoExample,
  WindowExample,
  ChartBarExample,
  ChartLineExample,
  ChartPieExample,
  TooltipExample,
  DataTableExample,
  InfiniteScrollExample,
} from "./pages"
import { HashRouter as Router, Switch, Route } from "react-router-dom"
import { MobileContext } from "./context"
import { Sidebar } from "./components/Sidebar"
import Home from "./Home"

import "./App.css"
function App() {
  const [mobileContext, setMobileContext] = useState(false)
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Sidebar />
      <MobileContext.Provider value={[mobileContext, setMobileContext]}>
        <Switch>
          <Route path="/accordion">
            <AccordionExample />
          </Route>
          <Route path="/animator">
            <AnimatorExample />
          </Route>
          <Route path="/ads">
            <AdsExample />
          </Route>
          <Route path="/button">
            <ButtonExample />
          </Route>
          <Route path="/bullet">
            <BulletExample />
          </Route>
          <Route path="/cardnavigation">
            <CardNavigationExample />
          </Route>
          <Route path="/carousel">
            <CarouselExample />
          </Route>
          <Route path="/chartline">
            <ChartLineExample />
          </Route>
          <Route path="/chartpie">
            <ChartPieExample />
          </Route>
          <Route path="/chartbar">
            <ChartBarExample />
          </Route>
          <Route path="/checkbox">
            <CheckboxExample />
          </Route>
          <Route path="/chip">
            <ChipExample />
          </Route>
          <Route path="/currencyinput">
            <CurrencyInputExample />
          </Route>
          <Route path="/datatable">
            <DataTableExample />
          </Route>
          <Route path="/datepicker">
            <DatePickerExample />
          </Route>
          <Route path="/formselect">
            <FormSelectExample />
          </Route>
          <Route path="/grid">
            <GridExample />
          </Route>
          <Route path="/hint">
            <HintExample />
          </Route>
          <Route path="/icon">
            <IconExample />
          </Route>
          <Route path="/image">
            <ImageExample />
          </Route>
          <Route path="/input">
            <InputExample />
          </Route>
          <Route path="/infiniteScroll">
            <InfiniteScrollExample />
          </Route>
          <Route path="/label">
            <LabelExample />
          </Route>
          <Route path="/list">
            <ListExample />
          </Route>
          <Route path="/login">
            <LoginExample />
          </Route>
          <Route path="/map">
            <MapExample />
          </Route>
          <Route path="/modal">
            <ModalExample />
          </Route>
          <Route path="/privacy">
            <PrivacidadeExample />
          </Route>
          <Route path="/qrcode">
            <QRCodeExample />
          </Route>
          <Route path="/bullet">
            <BulletExample />
          </Route>
          <Route path="/pagination">
            <PaginationExample />
          </Route>
          <Route path="/privacy">
            <PrivacidadeExample />
          </Route>
          <Route path="/radio">
            <RadioExample />
          </Route>
          <Route path="/segmentedcontrol">
            <SegmentedControlExample />
          </Route>
          <Route path="/select">
            <SelectExample />
          </Route>
          <Route path="/sellerperfil">
            <SellerPerfilExample />
          </Route>
          <Route path="/status">
            <StatusExample />
          </Route>
          <Route path="/slider">
            <SliderExample />
          </Route>
          <Route path="/tests">
            <TestsExample />
          </Route>
          <Route path="/text">
            <TextExample />
          </Route>
          <Route path="/textlink">
            <TextLinkExample />
          </Route>
          <Route path="/toggle">
            <ToggleExample />
          </Route>
          <Route path="/touchable">
            <TouchableExample />
          </Route>
          <Route path="/tooltip">
            <TooltipExample />
          </Route>
          <Route path="/sellerperfil">
            <SellerPerfilExample />
          </Route>
          <Route path="/valueinput">
            <ValueInputExample />
          </Route>
          <Route path="/view">
            <ViewExample />
          </Route>
          <Route path="/video">
            <VideoExample />
          </Route>
          <Route path="/window">
            <WindowExample />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </MobileContext.Provider>
    </Router>
  )
}

export default App
